module.exports = __webpack_public_path__ + "img/63.36e39019.jpg";